import type { ReactNode } from "react";

import { cx } from "../lib/format";

export type BadgeTone = "default" | "bright" | "success" | "warning" | "danger";

const TONES: Record<BadgeTone, string> = {
  default: "border-line text-muted",
  bright: "border-bright/40 text-bright",
  success: "border-success/60 text-success",
  warning: "border-warning/60 text-warning",
  danger: "border-danger/60 text-danger",
};

export interface BadgeProps {
  tone?: BadgeTone;
  /** Mono face — engine names, counts, statuses read as data. */
  mono?: boolean;
  className?: string;
  children: ReactNode;
}

export function Badge({ tone = "default", mono = false, className, children }: BadgeProps) {
  return (
    <span
      className={cx(
        "inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-xs leading-4",
        TONES[tone],
        mono && "font-mono",
        className,
      )}
    >
      {children}
    </span>
  );
}
